var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.block)?_c('h' + _vm.block.attributes.level,{tag:"component",class:'color-' + _vm.block.attributes.textColor},[_vm._v(_vm._s(_vm.block.attributes.content))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }